const orgList = {
    "HPORG20221177159475169527HP": 25,
    "HPORG202163715167403051171HP": 25,
    "HPORG2020123631162768861860HP": 25,
    "HPORG2018823132747633418701HP": 25,
    "HPORG2022829746416911543764HP": 25,
    "HPORG201882493295173833818HP": 25,
    "HPORG20191261051164391159519HP": 25,
    "HPORG202091151535805067104HP": 21,
    "HPORG201912184229269395909HP": 20,
    "HPORG20191117155934180026031HP": 17,
    "HPORG2022811039552993809207HP": 16,
    "HPORG2018814654389592233079HP": 16,
    "HPORG202299533221775109946HP": 14,
    "HPORG2022818100486186162513HP": 14,
    "HPORG20181030940448474301161HP": 13,
    "HPORG20191227643329875191104HP": 13,
    "HPORG2023228846302537005727HP": 13,
    "HPORG2023414105564749593568HP": 13,
    "HPORG2020817124614310214652HP": 12,
    "HPORG20202121324097771236HP": 12,
    "HPORG202246522227600999729HP": 12,
    "HPORG2020112533133314019142HP": 12,
    "HPORG2023321455155848484047HP": 10,
    "HPORG2019512757317420787453HP": 10,
    "HPORG2020610755374387102158HP": 10,
    "HPORG20188364632990584842HP": 10,
    "HPORG2022711235356865051820HP": 10,
    "HPORG2018620121338301639843HP": 10,
    "HPORG2022125959497184018268HP": 9,
    "HPORG20191114921351421482850HP": 9,
    "HPORG2020924104276436022047HP": 9,
    "HPORG2021826131722696263574HP": 9,
    "HPORG2019712112727441157230HP": 8,
    "HPORG2020914127286704461218HP": 8,
    "HPORG201712217332360551175HP": 8,
    "HPORG2019923955231257226618HP": 8,
    "HPORG2019875812533695240HP": 8,
    "HPORG202132353914289673709HP": 8,
    "HPORG2021713103469655068424HP": 8,
    "HPORG2019920715221544153080HP": 8,
    "HPORG20201224847595741795996HP": 8,
    "HPORG20231161013201687223547HP": 8,
    "HPORG202061532159674891657HP": 7,
    "HPORG2019226632243620931506HP": 7,
    "HPORG20191224625156265898287HP": 7,
    "HPORG2020227857274725256372HP": 7,
    "HPORG20181261012238810835185HP": 7,
    "HPORG202013091236176383827HP": 7,
    "HPORG20215196155201779668HP": 7,
    "HPORG201711181759205304321009HP": 7,
    "HPORG20193151024577772087142HP": 7,
    "HPORG201931593356212294874HP": 7,
    "HPORG20202261012535168512375HP": 7
};
export default orgList;